import { createRoot } from 'react-dom/client';
import Component from './design/component.js';
import { createDesignRoot } from './design/runtime.jsx';
import templateHtml from './design/template.html?raw';

// The design ships with these prop defaults (data-props in the .dc.html):
// majorScale = 1, showPips = true. Renders the verbatim design, exactly.
const PerspectiveRoot = createDesignRoot(templateHtml, Component, { majorScale: 1, showPips: true });

// Reuse the root across Vite HMR updates so dev doesn't warn about calling
// createRoot() twice on the same container. (A production load runs this once.)
const el = document.getElementById('root');
const root = (el.__perspectiveRoot ||= createRoot(el));
root.render(<PerspectiveRoot />);

// Installable + offline shell. Only in production builds: the dev server serves
// modules the cache-first worker would otherwise hold stale.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Chrome fires this when the app qualifies for installation. Hold onto the event
// so the UI can offer "Install" where people will actually see it, instead of
// relying on the address-bar icon almost nobody notices.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__perspectiveInstall = e;
  window.dispatchEvent(new CustomEvent('perspective:installable'));
});
window.addEventListener('appinstalled', () => {
  window.__perspectiveInstall = null;
  window.dispatchEvent(new CustomEvent('perspective:installed'));
});
